import {
	AGENCY_PROJECT,
	BRAND_STYLES,
	FILIALI_PROJECT,
	FUEL,
	PROJECT_CAR,
	PROJECT_CAR2,
	PROJECT_CAR_NEW,
	PROJECT_CRI,
	PROJECT_GRA,
	PROJECT_CSV,
	PROJECT_CSV2,
	RESTURANTS,
	setProjectCar,
	setProjectCsv,
	GEO_CMS_API_BASE_URL,
	GEOCMS_API,
	setGeoCMSApiBaseURL,
	setGeoCMSApiLicense,
	setGeoCMSApiVersion
} from '../utils/Constants';

export let TABS_TO_DISPLAY = [
	// PROJECT_CRI,
	PROJECT_CAR,
	PROJECT_GRA,
	AGENCY_PROJECT
	// RESTURANTS,
	// FUEL,
	// PROJECT_CAR_NEW
];

export let SHOW_ALL = false;

export let COLOR_PALETTE = null;

export let ICON_COLOR = '';

export let SHOW_TITLE = false;

export let SHOW_RANKED_BUTTON = false;

export let BRAND_STYLE = BRAND_STYLES.CIRCLE;

export let GOOGLE_MAPS_API_KEY = '';

export let GOOGLE_MAPS_CLIENT_ID = 'gme-axaitalia';

// COLORS TEST CASES

// COLOR_PALETTE = {
// 	'--axa-locator-primary': '#000090',
// 	'--axa-locator-primary-alt': '#2c2ec2',
// 	'--axa-locator-secondary': '#f07762',
// 	'--axa-locator-highlight': '#eaf1fa',
// 	'--axa-locator-tertiary': 'grey',
// 	'--axa-locator-bg': 'white',
// 	'--axa-locator-border': '#d2d2d2',
// 	'--axa-locator-tab-bg': '#d3e3f5',
// 	'--axa-locator-text': '#333',
// 	'--axa-locator-text-secondary': 'white',
// 	'--axa-locator-modal-bg': 'rgba(0, 0, 144, 0.4)',
// 	'--axa-locator-modal-body': '#f4f4f4'
// };

// COLOR_PALETTE = {
// 	'--axa-locator-primary': '#fc9403',
// 	'--axa-locator-primary-alt': '#fcb503',
// 	'--axa-locator-secondary': '#eb03fc',
// 	'--axa-locator-highlight': '#fcdb03',
// 	'--axa-locator-tertiary': 'grey',
// 	'--axa-locator-bg': 'white',
// 	'--axa-locator-border': '#d2d2d2',
// 	'--axa-locator-tab-bg': '#fcf003',
// 	'--axa-locator-text': '#333',
// 	'--axa-locator-text-secondary': 'white',
// 	'--axa-locator-modal-bg': 'rgba(0, 0, 144, 0.4)',
// 	'--axa-locator-modal-body': '#f4f4f4'
// };

export function setFromPortletConfiguration(config) {
	if (config) {
		if (config.TABS_TO_DISPLAY && config.TABS_TO_DISPLAY.length > 0) {
			TABS_TO_DISPLAY = config.TABS_TO_DISPLAY.split(',');
			for (let i = 0; i < TABS_TO_DISPLAY.length; i++) {
				const project = TABS_TO_DISPLAY[i];
				if (project === PROJECT_CAR || project === PROJECT_CAR2) {
					setProjectCar(project);
				} else if (
					project === PROJECT_CSV ||
					project === PROJECT_CSV2
				) {
					setProjectCsv(project);
				}
			}
		}

		if (config.SHOW_ALL) {
			SHOW_ALL = config.SHOW_ALL;
		}

		if (config.SHOW_TITLE) {
			SHOW_TITLE = config.SHOW_TITLE;
		}

		if (config.SHOW_RANKED_BUTTON) {
			SHOW_RANKED_BUTTON = config.SHOW_RANKED_BUTTON;
		}

		if (config.COLOR_PALETTE) {
			COLOR_PALETTE = config.COLOR_PALETTE;

			// Making the modal overlay semi-transparent...
			if (COLOR_PALETTE['--axa-locator-modal-bg'])
				COLOR_PALETTE['--axa-locator-modal-bg'] =
					COLOR_PALETTE['--axa-locator-modal-bg'] + '66';
		}

		if (config.ICON_COLOR) {
			ICON_COLOR = config.ICON_COLOR;
		}

		if (config.BRAND_STYLE) {
			BRAND_STYLE = config.BRAND_STYLE;
		}

		if (config.GEO_CMS_ENDPOINT) {
			setGeoCMSApiBaseURL(config.GEO_CMS_ENDPOINT);
		}

		if (config.GEO_CMS_LICENSE) {
			setGeoCMSApiLicense(config.GEO_CMS_LICENSE);
		}

		if (config.GEO_CMS_VERSION) {
			setGeoCMSApiVersion(config.GEO_CMS_VERSION);
		}

		if (config.GOOGLE_MAPS_API_KEY) {
			GOOGLE_MAPS_API_KEY = config.GOOGLE_MAPS_API_KEY;
		}

		if (config.GOOGLE_MAPS_CLIENT_ID) {
			GOOGLE_MAPS_CLIENT_ID = config.GOOGLE_MAPS_CLIENT_ID;
		}
	}
}
